import { render } from "./GradientList.vue?vue&type=template&id=1bfcb64d&scoped=true&ts=true"
import script from "./GradientList.vue?vue&type=script&lang=ts"
export * from "./GradientList.vue?vue&type=script&lang=ts"

import "./GradientList.vue?vue&type=style&index=0&id=1bfcb64d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfcb64d"]])

export default __exports__